<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="container-fluid">

      <div class="row" v-if="!isBalanceLoading">
        <div class="col-xl-6 col-md-6">
          <div class="card bg-warning bg-gradient card-height-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="avatar-sm flex-shrink-0">
                <span
                    class="avatar-title bg-soft-light text-white rounded-2 fs-2"
                >
                  <i class="ri-coin-line"></i>
                </span>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="fw-medium fs-4 text-white mb-3">کیف پول طلا</p>
                  <h4 class="fs-6 mb-3 text-white">
                    موجودی:
                    <count-to
                        :startVal="0"
                        :endVal="parseFloat(walletData.gold)"
                        :decimals="2"
                        :duration="1000"
                    ></count-to>
                    گرم
                  </h4>
                  <p class="text-white-50 mb-0 d-flex gap-2 align-items-center">
                    <button type="button"
                            @click="handleTransactions('gold')"
                            class="btn bg-dark bg-opacity-25 btn-label waves-effect waves-light text-light">
                      <i class="ri-file-list-2-line label-icon align-right fs-16 m-1"></i>
                      تراکنش‌ها
                    </button>
                    <button type="button"
                            @click="handleTransfer('gold')"
                            class="btn bg-dark bg-opacity-25 btn-label waves-effect waves-light text-light">
                      <i class="ri-exchange-box-line label-icon align-right fs-5 m-1"></i>
                      انتقال
                    </button>
                  </p>
                </div>
                <div class="flex-shrink-0 align-self-center"></div>
              </div>
            </div>
            <!-- end card body -->
          </div>
        </div>
        <div class="col-xl-6 col-md-6">
          <div class="card bg-primary bg-gradient card-height-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="avatar-sm flex-shrink-0">
                <span
                    class="avatar-title bg-soft-light text-white rounded-2 fs-2"
                >
                  <i class="ri-hand-coin-line"></i>
                </span>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="fw-medium fs-4 text-white mb-3">کیف پول ریالی</p>
                  <h4 class="fs-6 mb-3 text-white">
                    موجودی:
                    <count-to
                        :startVal="0"
                        :endVal="parseInt(walletData.toman)"
                        :decimals="0"
                        :duration="1300"
                    ></count-to>
                    تومان
                  </h4>
                  <p class="text-white-50 mb-0 d-flex gap-2 align-items-center">
                    <button type="button"
                            @click="handleTransactions('toman')"
                            class="btn bg-dark bg-opacity-25 btn-label waves-effect waves-light text-light">
                      <i class="ri-file-list-2-line label-icon align-right fs-16 m-1"></i>
                      تراکنش‌ها
                    </button>
                    <button type="button"
                            @click="handleTransfer('toman')"
                            class="btn bg-dark bg-opacity-25 btn-label waves-effect waves-light text-light">
                      <i class="ri-exchange-box-line label-icon align-right fs-5 m-1"></i>
                      انتقال
                    </button>
                  </p>
                </div>
                <div class="flex-shrink-0 align-self-center"></div>
              </div>
            </div>
            <!-- end card body -->
          </div>
        </div>
      </div>

      <div class="row" v-else>

        <div class="col-xl-6 col-md-6">
          <div class="card bg-dark opacity-25 bg-gradient card-height-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="avatar-sm flex-shrink-0">
                  <span class="avatar-title bg-soft-light text-white rounded-2 fs-2">
                  </span>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="fw-medium fs-4 text-white mb-3">
                    <Skeletor style="width: 100px; height: 20px !important;"/>
                  </p>
                  <h4 class="fs-6 mb-3 text-white">
                    <Skeletor style="width: 150px;"/>
                  </h4>
                  <p class="text-white-50 mb-0 d-flex gap-2 align-items-center">
                    <Skeletor style="width: 100px; height: 30px !important;"/>
                    <Skeletor style="width: 100px; height: 30px !important;"/>
                  </p>
                </div>
                <div class="flex-shrink-0 align-self-center"></div>
              </div>
            </div>
            <!-- end card body -->
          </div>
        </div>

        <div class="col-xl-6 col-md-6">
          <div class="card bg-dark opacity-25 bg-gradient card-height-100">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="avatar-sm flex-shrink-0">
                  <span class="avatar-title bg-soft-light text-white rounded-2 fs-2">
                  </span>
                </div>
                <div class="flex-grow-1 ms-3">
                  <p class="fw-medium fs-4 text-white mb-3">
                    <Skeletor style="width: 100px; height: 20px !important;"/>
                  </p>
                  <h4 class="fs-6 mb-3 text-white">
                    <Skeletor style="width: 150px;"/>
                  </h4>
                  <p class="text-white-50 mb-0 d-flex gap-2 align-items-center">
                    <Skeletor style="width: 100px; height: 30px !important;"/>
                    <Skeletor style="width: 100px; height: 30px !important;"/>
                  </p>
                </div>
                <div class="flex-shrink-0 align-self-center"></div>
              </div>
            </div>
            <!-- end card body -->
          </div>
        </div>

      </div>

      <div class="row" v-if="showTransactionsTable">
        <div class="col-12">
          <div class="card card-height-100">
            <div class="card-header align-items-center d-flex">
              <h4 class="card-title mb-0 flex-grow-1">تراکنش‌های کیف پول {{ labels[activeUnit] }}</h4>
              <div class="flex-shrink-0">
                <button v-if="!isTransactionsLoading" type="button" class="btn fs-4 p-0" @click="showTransactionsTable = false">
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
            <!-- end card header -->
            <div class="card-body pt-0">
              <ul class="list-group list-group-flush border-dashed p-0" v-if="!isTransactionsLoading && transactionsData[activeUnit].length">
                <li class="list-group-item ps-0 pe-0" v-for="(transaction, index) in transactionsData[activeUnit]"
                    :key="index">
                  <div class="row align-items-center g-3">
                    <div class="col-auto">
                      <div
                          v-if="transaction.amount > 0"
                          class="p-2 py-2 bg-success bg-opacity-25 rounded-3 text-light d-flex align-items-center justify-content-center"
                          style="width: 30px; height: 30px;">
                        <div class="text-center text-success fs-4">
                          <i class="ri-arrow-up-line"></i>
                        </div>
                      </div>
                      <div
                          v-if="transaction.amount < 0"
                          class="p-2 py-2 bg-danger bg-opacity-25 rounded-3 text-light d-flex align-items-center justify-content-center"
                          style="width: 30px; height: 30px;">

                        <div class="text-center text-danger fs-4">
                          <i class="ri-arrow-down-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="ext-reset fs-14 mb-0 fw-bold mb-2">
                        <NumericValue :amount="Math.abs(transaction.amount)" />
                        {{units[activeUnit]}}
                      </div>
                      <div class="text-muted mt-0 mb-1 fs-13">
                        {{ transaction.description }}
                      </div>
                    </div>
                    <div class="col-sm-auto">
                      <div class="ext-reset fs-14 mb-0 fw-normal mb-2">
                        <span>
                          مظنه ثبت:
                          <Price :amount="transaction.gold_second_price"/>
                        </span>
                      </div>
                      <div class="text-muted mt-0 mb-1 fs-13" style="text-align: left">
                        <Jalali :en-date="transaction.inserted_at"/>
                      </div>
                    </div>
                  </div>
                  <!-- end row -->
                </li>
              </ul>

              <div class="text-center" v-if="!isTransactionsLoading && !transactionsData[activeUnit].length">
                <lottie
                    class="avatar-xl"
                    colors="primary:#121331,secondary:#08a88a"
                    :options="defaultOptions"
                    :height="75"
                    :width="75"
                />
                <h5 class="mt-2">تراکنشی یافت نشد.</h5>
              </div>
              <ul class="list-group list-group-flush border-dashed p-0" v-if="isTransactionsLoading">
                <li class="list-group-item ps-0 pe-0" v-for="index in 4" :key="index">
                  <div class="row align-items-center g-3">
                    <div class="col-auto">
                      <Skeletor style="width: 30px; height: 30px;"/>

                    </div>
                    <div class="col">
                      <div class="ext-reset fs-14 mb-0 fw-bold mb-2">
                        <Skeletor style="width: 100px"/>
                      </div>
                      <div class="text-muted mt-0 mb-1 fs-13">
                        <Skeletor style="width: 100px"/>
                      </div>
                    </div>
                    <div class="col-sm-auto">
                      <Skeletor style="width: 100px"/>
                    </div>
                  </div>
                  <!-- end row -->
                </li>
              </ul>
              <!-- end -->
              <div class="align-items-center mt-2 row text-center text-sm-start" v-if="false">
                <div class="col-sm">

                </div>
                <div class="col-sm-auto">
                  <ul
                      class="
                    pagination pagination-separated pagination-sm
                    justify-content-center justify-content-sm-start
                    mb-0
                  "
                  >
                    <li class="page-item disabled">
                      <a href="#" class="page-link">←</a>
                    </li>
                    <li class="page-item">
                      <a href="#" class="page-link">1</a>
                    </li>
                    <li class="page-item active">
                      <a href="#" class="page-link">2</a>
                    </li>
                    <li class="page-item">
                      <a href="#" class="page-link">3</a>
                    </li>
                    <li class="page-item">
                      <a href="#" class="page-link">→</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- end card body -->
          </div>
          <!-- end card -->
        </div>
      </div>

      <div class="row" v-if="showTransferSection">
        <div class="col-12">
          <div class="card">
            <div class="card-header align-items-center d-flex">
              <h4 class="card-title mb-0 flex-grow-1">انتقال از کیف پول {{ labels[activeUnit] }}</h4>
              <div class="flex-shrink-0">
                <button v-if="!isTransferSectionLoading" type="button" class="btn fs-4 p-0" @click="showTransferSection = false">
                  <i class="ri-close-line"></i>
                </button>
              </div>
            </div>
            <!-- end card header -->
            <div class="card-body" v-if="!isTransferSectionLoading">
              <p class="text-muted">
                میتوانید موجودی کیف پول خود را به کیف پول دیگری انتقال دهید و یا به پنل درخواست برداشت انتقال دهید.
              </p>
              <div class="live-preview">
                <form @submit.prevent="doTransfer">
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">قیمت طلا</label>
                    </div>
                    <div class="col-lg-9">
                      <span>
                        <Price :amount="walletData.units.gold_second_price"/>
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">موجودی فعلی</label>
                    </div>
                    <div class="col-lg-9">
                      <span>
                        <NumericValue :amount="walletData[activeUnit]"/>
                        {{ units[activeUnit] }}
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">مقصد</label>
                    </div>
                    <div class="col-lg-9">
                      <select
                          class="form-select"
                          id="destination"
                          v-model="transferDestination"
                      >
                        <option value="0" selected>انتخاب کنید.</option>
                        <option value="toman" v-if="activeUnit === 'gold'">کیف پول ریالی</option>
                        <option value="gold" v-if="activeUnit === 'toman'">کیف پول طلا</option>
                        <option value="transaction">پنل درخواست برداشت</option>
                      </select>
                      <span class="field-error"
                            :class="(false) ? 'invalid' : 'd-none'">
                        مقصد انتقال
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">مقدار انتقال</label>
                    </div>
                    <div class="col-lg-9">
                      <input
                          type="number"
                          class="form-control number-input"
                          id="amount"
                          v-model="transferAmount"
                          :step="unitsStep[activeUnit]"
                          :max="walletData[activeUnit]"
                          :class="(transferAmount && walletData[activeUnit] < transferAmount) ? 'invalid' : ''"
                          placeholder="مقدار برداشت را وارد کنید."
                      />
                      <span class="field-error"
                            :class="(transferAmount && walletData[activeUnit] < transferAmount) ? 'invalid' : 'd-none'">
                        مقدار وارد شده نمیتواند بیشتر از موجودی باشد.
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3" v-if="activeUnit === 'gold' && transferDestination && transferAmount > 0">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">معادل ریالی</label>
                    </div>
                    <div class="col-lg-9">
                      <span>
                        <Price :amount="transferAmount * walletData.units.gold_second_price"/>
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3" v-if="activeUnit === 'toman' && transferDestination && transferDestination === 'gold' && transferAmount > 0">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">معادل طلایی</label>
                    </div>
                    <div class="col-lg-9">
                      <span>
                        <NumericValue :amount="transferAmount / walletData.units.gold_second_price"/>
                        گرم
                      </span>
                    </div>
                  </div>
                  <div class="row mb-3" v-if="transferAmount > 0 && transferDestination && transferFee">
                    <div class="col-lg-3 d-flex align-items-center">
                      <label for="amount" class="form-label m-0">کارمزد انتقال</label>
                    </div>
                    <div class="col-lg-9">
                      <span>
                        <Price :amount="transferFee()"/>
                        <span class="d-block text-muted" style="font-size: 12px">
                          کارمزد انتقال از معادل ریالی مقدار انتقال برداشت خواهد شد.
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="text-end">
                    <button type="submit" class="btn btn-primary"
                            :disabled="(!transferAmount || transferAmount <= 0 || !transferDestination || walletData[activeUnit] < transferAmount)">
                      انتقال
                    </button>
                  </div>

                  <div class="panel-spinner-overlay" v-if="isTransfering">
                    <b-spinner variant="warning"></b-spinner>
                  </div>
                </form>
              </div>
            </div>
            <div class="card-body" v-else>
              <p class="text-muted">
                <Skeletor style="width: 500px; max-width: 100%" />
              </p>
              <div class="live-preview">
                <form>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 100px;" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 100px;" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 300px; max-width: 100%" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 300px; max-width: 100%" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 80px;" />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-lg-3 d-flex align-items-center">
                      <Skeletor style="width: 100px;" />
                    </div>
                    <div class="col-lg-9">
                      <Skeletor style="width: 80px;" />
                    </div>
                  </div>
                  <div class="text-end">
                    <Skeletor style="width: 100px; height: 40px !important;" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import UserService from "@/services/user.service";
import {Skeletor} from "vue-skeletor";
import Lottie from "@/components/widgets/lottie";
import animationData from "@/components/widgets/msoeawqm.json";
import {CountTo} from "vue3-count-to";
import NumericValue from "@/views/globals/components/NumericValue.vue";

export default {
  name: "withdraw.vue",
  data() {
    return {
      title: "کیف پول",
      isBalanceLoading: true,
      isTransactionsLoading: false,
      isTransferSectionLoading: false,
      isTransfering: false,
      walletData: {},
      transactionsData: {},
      page: {
        gold: 1,
        toman: 1
      },
      units: {
        gold: 'گرم',
        toman: 'تومان'
      },
      unitsStep: {
        gold: '0.01',
        toman: '1'
      },
      labels: {
        gold: 'طلا',
        toman: 'ریالی'
      },
      transferAmount: false,
      transferDestination: 0,
      showTransactionsTable: false,
      showTransferSection: false,
      perPage: 10,
      pages: [],
      activeUnit: false,
      defaultOptions: {animationData: animationData},
    };
  },
  page: {
    title: "کیف پول",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NumericValue,
    CountTo,
    Layout,
    PageHeader,
    Skeletor,
    Lottie
  },
  created() {
    this.fetchPromises();
  },
  watch: {
    withdrawList() {
      this.setPages();
    },
  },
  methods: {
    transferFee() {
      if(this.transferAmount <= 0)
        return 0

      if(!this.walletData || !this.walletData.fees)
        return 0

      const fee = this.walletData.fees[this.activeUnit + '-' + this.transferDestination]
      if(!fee)
        return 0

      if(fee.type === 'static')
        return fee.amount

      let base = 1
      if(this.activeUnit === 'toman') {
        base = 1
      } else {
        base = this.activeUnit === 'gold' ? this.walletData.units.gold_second_price : this.walletData.units[this.activeUnit + '_price']
      }

      return fee.amount * this.transferAmount * base / 100

    },
    handleWalletBalance() {
      this.isBalanceLoading = true;
      return this.getWalletData()
    },
    handleTransfer(unit) {
      this.activeUnit = unit
      this.isTransferSectionLoading = true
      this.showTransactionsTable = false
      this.showTransferSection = true
      this.transferAmount = false
      this.transferDestination = 0
      this.getWalletData()
    },
    handleTransactions(unit) {
      this.activeUnit = unit
      this.showTransferSection = false
      this.showTransactionsTable = true
      this.getTransactions(unit)
    },
    getTransactions(unit) {
      this.isTransactionsLoading = true
      return UserService.getTransactions(unit, this.perPage, this.page[this.activeUnit])
          .then((response) => {
            const {data} = response;
            this.isTransactionsLoading = false
            this.transactionsData[unit] = data
          })
    },
    getWalletData() {
      return UserService.getWalletData()
          .then((response) => {
            const {data} = response
            this.walletData = data
            this.isBalanceLoading = false
            this.isTransferSectionLoading = false
          });
    },
    doTransfer() {
      this.isTransfering = true
      return UserService.walletTransfer(this.activeUnit, this.transferDestination, this.transferAmount)
          .then((response) => {

            const {data} = response
            this.walletData = data.wallet
            this.$notify({
              title: response.data.message,
              type: 'success',
            })
            this.isTransferSectionLoading = false
            this.showTransactionsTable = false
            this.showTransferSection = true
            this.transferAmount = false
            this.transferDestination = 0

            this.handleTransactions(this.activeUnit)
          }, (error) => {
            this.$notify({
              title: "خطا",
              text: error.message,
              type: 'error',
            });
          })
          .then(() => {
            this.isTransfering = false
          });
    },
    fetchPromises() {
      this.isTransactionsLoading = true;
      Promise.all([
        this.handleWalletBalance(),
      ])
    },

    setPages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.withdrawTotalCount / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(transactions) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return transactions.slice(from, to);
    },
    SearchData() {
      this.resultQuery;
    },
  }
}
</script>

<style scoped>
.number-input {
  text-align: left;
}

.number-input::placeholder {
  text-align: right;
}

span.field-error {
  position: absolute;
  font-size: 10px;
  top: -7px;
  right: 20px;
  background: #FFF;
  padding: 0 5px;
  color: #FF0000;
}

.invalid {
  border-color: #FF0000;
}
</style>
